<template>
  <div>
    <!-- <div :class="$style.title">
      <h3 class=" text-lg text-dark font-medium">{{ count }}个出发日期可选</h3>
      <p class="ml-auto"><i class="el-icon-information"></i>所列价格为单人不含税起价，基于双人入住</p>
    </div> -->

    <table :class="$style.table">
      <thead >
        <tr>
          <th class="sticky" :style="{top: `${offsetTop}px`}">出发-到达</th>
          <th class="sticky" :style="{top: `${offsetTop}px`}" v-for="cabin in cabins" :key="cabin.key">{{ cabin.value }}</th>
          <th :style="{top: `${offsetTop}px`}" class="text-center sticky">预订</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="date in limitDates" :key="date.id">
          <td>
            <ul :class="$style.dates">
              <li :class="$style.date"><i class="ficon ficon-ziyuancaigou_chufa" /><span class="ml-2">{{date.date}}</span></li>
              <li :class="$style.date"><i class="ficon ficon-ziyuancaigou_daoda" /><span class="ml-2">{{date.back_date}}</span></li>
            </ul>
          </td>
          <td v-for="cabin in cabins" :key="cabin.key">
            <table-price-cell v-bind="date.data[cabin.key]" :isDistributor="isDistributor" />
          </td>
          <td>
            <el-button class="w-29" :class="$style.disabled__btn" v-if="saleStatus == 0" disabled>不可预订</el-button>
            <el-button class="w-29" type="primary" v-else @click="onBooking(date)">预订</el-button>
          </td>
        </tr>
      </tbody>
    </table>

    <div v-if="isLimit" :class="$style.footer">
      <button :class="$style.moreBtn" @click="isLimit = false">查看全部<i class="el-icon-arrow-right" /></button>
    </div>
  </div>
</template>
<script>
import {
	computed,
	defineComponent,
	useRouter,
	useStore,
	ref
} from "@nuxtjs/composition-api";
import useMessage from "~/composables/useMessage";
import { REQUEST_CODES } from "~/constants/const-http";
import { submitCruiseTicketBooking } from "~/services/order";

import useLoginDialog from '~/composables/useLoginDialog'
import TablePriceCell from './table-price-cell.vue'

export default defineComponent({
	name: "ProductDetailDates",
	components: {
		TablePriceCell
	},
	props: {
		count: [Number, String],
		offsetTop: {
			type: Number,
			default: 0
		},
		dates: {
			type: Array,
			default: () => []
		},
		cabins: {
			type: Array,
			default: () => []
		},
		productNo: String,
    saleStatus: {
      type: Number,
			default: 1
    }
	},
	setup(props) {
		const router = useRouter();
		const $message = useMessage();
		const store = useStore();
		const {
			showLogin
		} = useLoginDialog();
		async function onBooking(stock) {
			if (!store.getters.loggedIn) {
				showLogin();
				return;
			}
			if(!store.getters.isDistributor){
				router.push('/settled/process')
				return
			}
			// if(!store.){}
			const { code, data, msg } = await submitCruiseTicketBooking({
				date: stock.date,
				product_no: props.productNo,
				supplier_id: stock.supplier_id
			});
			if (code !== REQUEST_CODES.ERROR_OK) {
				$message.error(msg);
				return;
			}

			router.push({
				path: "placeorder",
				query: {
					booking_no: data.booking_no
				}
			});
		}

		const isLimit = ref(props.dates.length > 5);
		const limitDates = computed(() =>
			isLimit.value ? props.dates.slice(0, 5) : props.dates
		);
		return {
			isLimit,
			limitDates,
			onBooking
		};
	},

	computed: {
		isDistributor() {
			if (!this.$store.getters.loggedIn) {
				return false;
			}
			// if (!this.auth.loggedIn) return false;
			return !!this.$store.getters.userInfo.distributor;
		}
	}
});
</script>
<style lang="scss" module>
.title {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
}
.table {
  border-collapse: collapse;
  font-size: 1rem;
  line-height: 1.5rem;
  width: 100%;
}
.table th {
  --tw-bg-opacity: 1;
  background-color: rgba(244, 244, 244, var(--tw-bg-opacity));
  font-weight: 500;
  text-align: left;
  --tw-text-opacity: 1;
  color: rgba(25, 25, 25, var(--tw-text-opacity));
  z-index: 2;
}
.table th, .table td {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.table td {
  border-bottom-width: 1px;
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.date {
  padding-bottom: 0.5rem;
  position: relative;
}
.date::before {
  content: "";
  left: 7px;
  top: 20px;
  --tw-border-opacity: 1;
  border-color: rgba(96, 99, 112, var(--tw-border-opacity));
  border-style: dashed;
  border-left-width: 1px;
  height: 1rem;
  position: absolute;
  width: 0px;
}
.date:last-child::before {
  display: none;
}
.date:last-child {
  margin-bottom: 0px;
  padding-bottom: 0px;
}
.footer {
  text-align: center;
}
.moreBtn {
  margin-top: 1.5rem;
  --tw-text-opacity: 1;
  color: rgba(25, 25, 25, var(--tw-text-opacity));
}
.disabled__btn {
  background: #D8D8D8 !important;
  color: #fff !important;
  border: none !important;
}
</style>
